import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { ArrowLeft } from 'lucide-react';
import { hasNavigationState, getNavigationState, navigateBack } from '../utils/navigationState';

const BackToResultsButton = ({ className = "" }) => {
  const navigate = useNavigate();
  
  // Only show if we have saved navigation state
  if (!hasNavigationState()) {
    return null;
  }

  const state = getNavigationState();
  
  // Determine the button text based on where we came from
  let buttonText = 'Back to Results';
  if (state?.pageName) {
    buttonText = `Back to ${state.pageName}`;
  } else if (state?.path) {
    if (state.path.includes('matching')) {
      buttonText = 'Back to Matching';
    } else if (state.path.includes('resources')) {
      buttonText = 'Back to Resources';
    } else if (state.path.includes('projects')) {
      buttonText = 'Back to Projects';
    } else if (state.path.includes('favorites')) {
      buttonText = 'Back to Favorites';
    }
  }

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={() => navigateBack(navigate)}
      className={className}
    >
      <ArrowLeft className="w-4 h-4 mr-2" />
      {buttonText}
    </Button>
  );
};

export default BackToResultsButton;
